module.exports = __webpack_public_path__ + "img/jazz_xxl_brown_ba_list.bd8bb91b.jpg";